<div class="flex flex-col space-y-xxs">
  <strong>
    <a href="login">Click here if you are not re-directed</a>
  </strong>
</div>
